import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const general = {
	missingRequiredParam: "Chybí povinný parametr '{{paramName}}'.",
	notNumber: "Parametr '{{paramName}}' musí být číslo.",
	unknownTargetPage: "Parametr 'targetPage' obsahuje hodnotu, která nenní podporovaná.",
};

const page = {
	pageTitle: 'Litujeme, vstupní parametry nejsou správné.',
	pageInputs: 'Přijaté vstupní parametry:',
	continueLabel: 'Pokračovat',
};

const merge = {
	...general,
	...page,
};

export default Object.assign({}, merge, createLabeledMessages({ ...merge }));
